import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Card } from 'react-bootstrap'

import { Can } from '../../../../_contexts/AbilitiesContext'

export default function PatientsEmpty() {
  return (
    <Card style={{ border: '0px' }}>
      <Card.Body>
        <h5 className='font-weight-bold'>
          No Patients To Display.
        </h5>
        <div className='my-4'>
          Patients will appear here after they have completed a Form or Telehealth appointment. Start by sending a Form or scheduling a Telehealth appointment below.
        </div>

        <div className="row">

          <Can I="send" a="form">
            <div className="col-auto">
              <Button as={Link} to='/forms/schedule' variant='outline-primary' className="px-5">
                Send Form
              </Button>
            </div>
          </Can>

          <Can I="schedule" a="teleahealth">
            <div className="col">
              <Button as={Link} to='/telehealth/schedule' variant='outline-primary' className="px-5">
                Schedule Telehealth
              </Button>
            </div>
          </Can>

        </div>
      </Card.Body>
    </Card>
  )
}
